import React from 'react';
import classNames from 'classnames';

import css from './IconShield.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconShield = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="48"
      height="48"
      viewBox="0 0 800 800"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M452.184,64.414l-13.12-2.624C378.866,49.751,320.505,29.724,265.538,2.251c-6.004-3.001-13.071-3.001-19.075,0
				C191.478,29.733,133.136,49.754,72.938,61.79l-13.121,2.624c-9.972,1.994-17.149,10.75-17.149,20.919v78.549
				c0,91.952,36.531,180.151,101.544,245.165l96.704,96.704c8.331,8.331,21.839,8.331,30.17,0l96.704-96.704
				c65.014-65.014,101.544-153.213,101.544-245.165V85.333C469.333,75.164,462.156,66.409,452.184,64.414z M426.667,163.883
				c0,80.636-32.036,157.983-89.048,214.995L256,460.497l-81.619-81.619c-57.012-57.012-89.048-134.359-89.048-214.995v-61.072
				C144.359,90.665,201.669,71.279,256,45.097c54.318,26.174,111.642,45.564,170.667,57.714V163.883z" />
      <path d="M185.756,198.244c-8.331-8.331-21.839-8.331-30.17,0s-8.331,21.839,0,30.17l64,64c8.87,8.87,23.443,8.209,31.474-1.428
				l106.667-128c7.543-9.051,6.32-22.503-2.731-30.046c-9.051-7.543-22.503-6.32-30.046,2.731l-91.712,110.054L185.756,198.244z" />
    </svg>
  );
};

export default IconShield;
